import { styled } from "styled-components";

export const Container = styled.div`
    background-color: ${({ theme }) => theme.white};
    padding: 38px 42px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.gray100};
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 70%;
`;

export const Title = styled.h1`
    color: ${({ theme }) => theme.gray600};
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    letter-spacing: 0.03px;
`;
